import { Form, Badge, Table } from 'react-bootstrap';
import Moment from 'react-moment';
import VerifiedSignature from "../../../../img/documentsign.png"

const FormSignatureData = ({
    setToggle,
    DBPSignatureBy,
    DBPQualityCheck,
    DBPSignatureDT,
    DBPSignatureCode,
    DVSignatureCode,
    DVQualityCheck,
    DVSignatureBy,
    DVSignatureDT,
    footer,
}) => {
    const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
    const firstName = JSON.parse(localStorage.getItem("firstName"));
    const lastName = JSON.parse(localStorage.getItem("lastName"));
    return (
        <>
            {footer && (StudyMode === "DBP Mode" || DBPQualityCheck === "yes") &&
                <Form.Group id="footer" className="mb-2 bg-white">
                    <div className="bg-light border rounded p-2 mt-4 position-relative">
                       <Badge
                            className="position-absolute text-muted bg-success-subtle br3"
                            style={{ top: -10, left: 20 }}
                        >
                            Signature
                        </Badge>
                        <div className="p-2 pt-3">
                            <Table
                                bordered
                                className="m-0 border signTable bg-white"
                                style={{ verticalAlign: "middle" }}
                            >
                                <tbody>
                                    {(StudyMode === "DBP Mode" || DBPQualityCheck === "yes") &&
                                        <>
                                            <tr>
                                                <td
                                                    className="text-end"
                                                    style={{ width: 150 }}
                                                >
                                                    Designed By:{" "}
                                                </td>
                                                {DBPQualityCheck === "no" &&
                                                    <>
                                                        <td>{`${firstName} ${lastName}`}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-outline-secondary p-1 br3 px-3"
                                                                style={{ fontSize: 12 }}
                                                                onClick={() => setToggle()}
                                                            >
                                                                Signature
                                                            </button>
                                                        </td>
                                                    </>
                                                }
                                                {DBPQualityCheck === "yes" &&
                                                    <>
                                                        <td>{DBPSignatureBy}</td>
                                                        <td className="p-3">
                                                            <div
                                                                className="border border-2 rounded-start border-success border-end-0 position-relative"
                                                                style={{ maxWidth: "fit-content" }}
                                                            >
                                                                <div className="p-3">
                                                                    <div className="hstack gap-2">
                                                                        <h6 className="m-0 fw-bold">
                                                                            {DBPSignatureBy?.split(" ")[0]}
                                                                            <br />
                                                                            {DBPSignatureBy?.split(" ")[1]}
                                                                        </h6>
                                                                        <div>
                                                                            <p
                                                                                className="m-0"
                                                                                style={{ fontSize: 9 }}
                                                                            >
                                                                                Digitally signed by
                                                                                <br />
                                                                                {DBPSignatureBy}
                                                                            </p>
                                                                            <p
                                                                                className="m-0"
                                                                                style={{ fontSize: 9 }}
                                                                            >
                                                                                Date: <Moment format="DD/MM/YYYY" withTitle>
                                                                                    {DBPSignatureDT}
                                                                                </Moment> |
                                                                                <br />
                                                                                <Moment format="HH:mm:ss" withTitle>
                                                                                    {DBPSignatureDT}
                                                                                </Moment> - GMT+06:30
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="position-absolute bg-white w-100"
                                                                    style={{ top: -10, left: 30 }}
                                                                >
                                                                    <p className="fw-bold m-0 ps-1">
                                                                        eSigned By:
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    className="position-absolute bg-white w-100"
                                                                    style={{ bottom: -10, left: 30 }}
                                                                >
                                                                    <p className="fw-bold m-0 ps-1">
                                                                        {DBPSignatureCode}
                                                                    </p>
                                                                </div>
                                                                <img className='position-absolute' style={{ top: 8, left: 47, pointerEvents: "none", filter: "opacity(0.2)", width: 70 }} src={VerifiedSignature} alt="Signed" />
                                                            </div>
                                                        </td>
                                                    </>
                                                }
                                            </tr>
                                        </>
                                    }
                                    {(StudyMode === "DV Mode" || DVQualityCheck === "yes") &&
                                        <>
                                            <tr>
                                                <td
                                                    className="text-end"
                                                    style={{ width: 150 }}
                                                >
                                                    DV By:{" "}
                                                </td>
                                                {DVQualityCheck === "no" &&
                                                    <>
                                                        <td>{`${firstName} ${lastName}`}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-outline-secondary p-1 br3 px-3"
                                                                style={{ fontSize: 12 }}
                                                                onClick={() => setToggle()}
                                                            >
                                                                Signature
                                                            </button>
                                                        </td>
                                                    </>
                                                }
                                                {DVQualityCheck === "yes" &&
                                                    <>
                                                        <td>{DVSignatureBy}</td>
                                                        <td className="p-3">
                                                            <div
                                                                className="border border-2 rounded-start border-success border-end-0 position-relative"
                                                                style={{ maxWidth: "fit-content" }}
                                                            >
                                                                <div className="p-3">
                                                                    <div className="hstack gap-2">
                                                                        <h6 className="m-0 fw-bold">
                                                                            {DVSignatureBy?.split(" ")[0]}
                                                                            <br />
                                                                            {DVSignatureBy?.split(" ")[1]}
                                                                        </h6>
                                                                        <div>
                                                                            <p
                                                                                className="m-0"
                                                                                style={{ fontSize: 9 }}
                                                                            >
                                                                                Digitally signed by
                                                                                <br />
                                                                                {DVSignatureBy}
                                                                            </p>
                                                                            <p
                                                                                className="m-0"
                                                                                style={{ fontSize: 9 }}
                                                                            >
                                                                                Date: <Moment format="DD/MM/YYYY" withTitle>
                                                                                    {DVSignatureDT}
                                                                                </Moment> |
                                                                                <br />
                                                                                <Moment format="HH:mm:ss" withTitle>
                                                                                    {DVSignatureDT}
                                                                                </Moment> - GMT+06:30
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="position-absolute bg-white w-100"
                                                                    style={{ top: -10, left: 30 }}
                                                                >
                                                                    <p className="fw-bold m-0 ps-1">
                                                                        eSigned By:
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    className="position-absolute bg-white w-100"
                                                                    style={{ bottom: -10, left: 30 }}
                                                                >
                                                                    <p className="fw-bold m-0 ps-1">
                                                                        {DVSignatureCode}
                                                                    </p>
                                                                </div>
                                                                <img className='position-absolute' style={{ top: 8, left: 47, pointerEvents: "none", filter: "opacity(0.2)", width: 70 }} src={VerifiedSignature} alt="Signed" />
                                                            </div>
                                                        </td>
                                                    </>
                                                }
                                            </tr>
                                        </>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Form.Group>
            }
        </>
    )
}

export default FormSignatureData